import { Button, Result } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import withLayout from 'components/layout'

import helpAndFeedback from 'constants/helpAndFeedback'

import './noModuleAccess.less'

const NoModuleAccess = () => {
  const { t } = useTranslation()

  return (
    <div className="no-module-access__container">
      <Result
        status="403"
        subTitle={t('noModuleAccess.description')}
        title={t('noModuleAccess.title')}
        extra={
          <Button href={helpAndFeedback.cargoMateMailto} type="primary">
            {t('noModuleAccess.contactSupport')}
          </Button>
        }
      />
      <div className="no-module-access__support">
        {`${t('login.contactSupport')} ${helpAndFeedback.cargoMateEmail}`}
      </div>
    </div>
  )
}

export default withLayout(NoModuleAccess)
